export const PhoneVerificationMethod = Object.freeze({
  SMS: "SMS",
  WHATSAPP: "WHATSAPP"
});
